import React from 'react';
import { ArrowDown } from 'lucide-react';
export function Hero() {
  return <section className="w-full min-h-[80vh] flex flex-col md:flex-row border-b border-black" data-id="element-132">
      {/* Left Column - 60% */}
      <div className="w-full md:w-[60%] p-8 md:p-16 lg:p-24 flex flex-col justify-center border-b md:border-b-0 md:border-r border-black bg-white relative" data-id="element-133">
        <div className="absolute top-8 left-8 md:top-12 md:left-12" data-id="element-134">
          <span className="text-sm font-bold tracking-widest uppercase text-[var(--color-swiss-red)]" data-id="element-135">
            Est. 2024
          </span>
        </div>

        <h1 className="text-6xl md:text-7xl lg:text-8xl font-bold leading-[0.9] tracking-tighter mb-12" data-id="element-136">
          Precision
          <br data-id="element-137" />
          Wealth
          <br data-id="element-138" />
          Planning.
        </h1>

        <p className="text-xl md:text-2xl leading-relaxed max-w-lg mb-12 font-normal text-gray-600" data-id="element-139">
          Objective financial guidance based on mathematical certainty. No
          speculation, just calculation.
        </p>

        <div className="flex items-center gap-8" data-id="element-140">
          <button className="swiss-btn" data-id="element-141">Start Planning</button>
          <a href="#calculators" className="flex items-center gap-2 text-sm font-bold uppercase tracking-widest hover:text-[var(--color-swiss-red)] transition-colors" data-id="element-142">
            Explore Tools <ArrowDown className="w-4 h-4" data-id="element-143" />
          </a>
        </div>
      </div>

      {/* Right Column - 40% */}
      <div className="w-full md:w-[40%] bg-[#F5F5F5] p-8 md:p-16 flex flex-col justify-between relative overflow-hidden" data-id="element-144">
        {/* Abstract Geometric Decoration */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-[var(--color-swiss-red)] opacity-10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 pointer-events-none" data-id="element-145"></div>

        <div className="space-y-12 relative z-10" data-id="element-146">
          <div className="border-l-2 border-[var(--color-swiss-red)] pl-6" data-id="element-147">
            <h3 className="text-lg font-bold mb-2" data-id="element-148">Market Analysis</h3>
            <p className="text-gray-600 text-sm leading-relaxed" data-id="element-149">
              Real-time data processing with algorithmic precision to ensure
              optimal asset allocation.
            </p>
          </div>

          <div className="border-l-2 border-black pl-6" data-id="element-150">
            <h3 className="text-lg font-bold mb-2" data-id="element-151">Risk Management</h3>
            <p className="text-gray-600 text-sm leading-relaxed" data-id="element-152">
              Calculated exposure strategies designed to preserve capital while
              maximizing growth potential.
            </p>
          </div>

          <div className="border-l-2 border-black pl-6" data-id="element-153">
            <h3 className="text-lg font-bold mb-2" data-id="element-154">Tax Efficiency</h3>
            <p className="text-gray-600 text-sm leading-relaxed" data-id="element-155">
              Strategic structuring to minimize liability and enhance net
              returns over long-term horizons.
            </p>
          </div>
        </div>

        <div className="mt-12 pt-12 border-t border-gray-300" data-id="element-156">
          <div className="flex justify-between items-end" data-id="element-157">
            <div data-id="element-158">
              <div className="text-5xl font-bold mb-1" data-id="element-159">14.2%</div>
              <div className="text-xs uppercase tracking-widest text-gray-500" data-id="element-160">
                Avg. Annual Return
              </div>
            </div>
            <div className="text-right" data-id="element-161">
              <div className="text-5xl font-bold mb-1" data-id="element-162">0.0%</div>
              <div className="text-xs uppercase tracking-widest text-gray-500" data-id="element-163">
                Hidden Fees
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}